import type { InlineBanner } from '@/mocks/ads';

interface InlineBannerAdProps {
  banner: InlineBanner;
  className?: string;
}

export default function InlineBannerAd({ banner, className = '' }: InlineBannerAdProps) {
  return (
    <div className={`w-full ${className}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden cursor-pointer group hover:border-primary-200 transition-all duration-300">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-2/5 lg:w-1/3 h-40 md:h-auto overflow-hidden">
              <img
                src={banner.imageUrl}
                alt={banner.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-2">
                <span className="inline-block px-2.5 py-1 bg-foreground-100 text-foreground-500 text-[10px] font-semibold rounded-md uppercase tracking-wider">
                  Publicidad
                </span>
                <span className="text-foreground-400 text-[10px] font-medium">{banner.size}</span>
              </div>
              <h3 className="text-foreground-950 font-semibold text-sm md:text-base mb-1.5">
                {banner.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-3">
                {banner.description}
              </p>
              <a
                href={banner.ctaUrl}
                className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-semibold text-xs md:text-sm transition-colors whitespace-nowrap w-fit"
              >
                {banner.ctaText}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}